import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigationModule, ResourceModule, AuthGuardService } from '@smartsoftware/reflex-core';
import { AestheticsModule } from '../../aesthetics/aesthetics.module';
import { ComponentsModule } from '../../components/components.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LegalReflexLibModule } from 'legalreflex-lib';
import { SSOFrame } from './frame/frame';
import { EntraView } from './entra/view';
import { OktaView } from './okta/view';
const routes: Routes = [
    {
        path: 'sso',
        component: SSOFrame,
        children: [
            {
                path: 'entra',
                component: EntraView,
            },
            {
                path: 'okta',
                component: OktaView,
            }
        ]
    }
];

@NgModule({
    declarations: [
        SSOFrame,
        EntraView,
        OktaView
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AestheticsModule,
        ComponentsModule,
        ResourceModule,
        BrowserModule,
        BrowserAnimationsModule,
        MatTooltipModule,
        RouterModule,
        LegalReflexLibModule,
        MatFormFieldModule,
        MatInputModule,
        RouterModule.forChild(routes)
    ],
    exports: [

    ],
    bootstrap: [

    ]
})
export class SSOModule { }